export default __webpack_public_path__ + "img/2b943e5ea929d49d9bf4e5c9df9d250a.svg";